import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


export const bird = () => {

// gsap.registerPlugin(ScrollTrigger);


// const screenWidth = window.innerWidth; // Get the current screen width
// let xValue;

// // Determine the x value based on screen width
// if (screenWidth < 576) {
//     xValue = "calc(100vw + 300px)"; // For very small screens
// } else if (screenWidth < 992) {
//     xValue = "calc(100vw + 500px)"; // For screens between 576px and 992px
// } else if (screenWidth < 1366) {
//     xValue = "150vw"; // For screens between 992px and 1366px
// } else {
//     xValue = "180vw"; // For larger screens
// }
// // Set up the animation
// gsap.to(".cloud1", {
//     x: xValue, // Move the cloud horizontally to the right
    
//     scrollTrigger: {
//         trigger: ".scroll-container", // The container that triggers the animation
//         start: "top top", // When the top of the trigger hits the top of the viewport
//         end: "bottom -1000px", // When the bottom of the trigger hits the top of the viewport
//         scrub: true, // Smoothly scrubs the animation based on the scroll position
//     },
// });




}

